import { fetchGlobalSections, fetchGlobalConfig } from '@/api'

export const useGlobalStore = defineStore('globalStore', () => {
  const bankListOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const currencyOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const statusOptions = ref([{
    label: 'All',
    value: '0',
  }])

  const documentTypeOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const limitTypeOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const periodTypeOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const targetOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const tradeOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const pixKeyTypeOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const pixKeyStatusOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const ispbOptions = ref([
    {
      label: 'All',
      value: '0',
    },
  ])

  const infractionsTaskStatusOptions =  ref([
    {
      label: 'All',
      value: '0',
    },
    {
      label: 'Open',
      value: 'open',
    },
    {
      label: 'Received',
      value: 'received',
    },
    {
      label: 'Closed',
      value: 'closed',
    },
    {
      label: 'Canceled',
      value: 'canceled',
    },
  ])

  const tradeTypeOptions =  ref([
    {
      label: 'All',
      value: '0',
    },
    {
      label: 'Payin',
      value: 'payin',
    },
    {
      label: 'Payout',
      value: 'payout',
    }
  ])

  const bankConfigLoading = ref(false)
  let bankConfigRequestDepth = 0

  async function getGlobalConfig() {
    bankConfigRequestDepth += 1
    bankConfigLoading.value = true
    try {
      const res = await fetchGlobalConfig({})
      if (res?.code !== 200 || !res?.data?.bank_list) {
        return
      }
      const bankList = res.data.bank_list
        .filter(item => (item.bank_name || '').toLowerCase().includes('pagsmile ip'))
        .map(item => ({
          label: item.bank_name,
          value: item.ispb,
        }))
      bankListOptions.value = arrayDeduplication(bankListOptions.value.concat(bankList))
    } catch (err) {
      console.error('getGlobalConfig failed:', err)
    } finally {
      bankConfigRequestDepth -= 1
      if (bankConfigRequestDepth <= 0) {
        bankConfigRequestDepth = 0
        bankConfigLoading.value = false
      }
    }
  }
  async function getGlobalSections() {
    // const res = await fetchGlobalSections()
    // console.log(res, 'res')
    // if (res.code === 200) {
    //   const currencyList = res.data.currency.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })

    //   currencyOptions.value = arrayDeduplication(currencyOptions.value.concat(currencyList))

    //   const statusList = res.data.status.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })

    //   statusOptions.value =  arrayDeduplication(statusOptions.value.concat(statusList))

    //   const documentTypeList = res.data.doc_type.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })

    //   documentTypeOptions.value = arrayDeduplication(documentTypeOptions.value.concat(documentTypeList))

    //   const limitTypeList = res.data.limits_type.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })

    //   limitTypeOptions.value = arrayDeduplication(limitTypeOptions.value.concat(limitTypeList))

    //   const periodTypeList = res.data.period_type.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })

    //   periodTypeOptions.value = arrayDeduplication(periodTypeOptions.value.concat(periodTypeList))

    //   const targetList = res.data.target.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })

    //   targetOptions.value = arrayDeduplication(targetOptions.value.concat(targetList))

    //   const tradeList = res.data.trade_status.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })

    //   tradeOptions.value = arrayDeduplication(tradeOptions.value.concat(tradeList))

    //   const pixKeyTypeList = res.data.pix_key_type.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })
      
    //   pixKeyTypeOptions.value = arrayDeduplication(pixKeyTypeOptions.value.concat(pixKeyTypeList))

    //   const pixKeyStatusList = res.data.pix_key_status.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })
      
    //   pixKeyStatusOptions.value = arrayDeduplication(pixKeyStatusOptions.value.concat(pixKeyStatusList))

    //   const ispbList = res.data.ispb.map(item => {
    //     return {
    //       label: item.name,
    //       value: item.code,
    //     }
    //   })

    //   ispbOptions.value = arrayDeduplication(ispbOptions.value.concat(ispbList))
    // }
  }
  
  return {
    currencyOptions,
    statusOptions,
    documentTypeOptions,
    limitTypeOptions,
    periodTypeOptions,
    targetOptions,
    tradeTypeOptions,
    tradeOptions,
    pixKeyTypeOptions,
    pixKeyStatusOptions,
    ispbOptions,
    infractionsTaskStatusOptions,
    bankListOptions,
    bankConfigLoading,
    getGlobalSections,
    getGlobalConfig,
  }
})
